import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import useFetch from 'src/hooks/useFetch';

import Container from 'src/components/Layouts/Container';
import { Title } from 'src/components/Layouts/Container/styles';

import CardPlano from './CardPlano';

export function ContratarAssinatura(props) {
  const { planoId } = props;

  const history = useHistory();

  const { isLoading, data } = useFetch(`/buscarPlanoAssinatura/${planoId}`);

  const onCardPress = (plano) => {
    history.push({
      pathname: '/PagamentoComCartao',
      state: {
        type: 'ASSINATURA',
        isOpeningCompany: false,
        plano,
      },
    });
  };

  return (
    <Container isLoading={isLoading}>
      <Title>Planos de Assinatura</Title>
      <div>
        {data?.length > 0 &&
          data.map((planItem) => {
            return (
              <CardPlano
                key={planItem?.id}
                plan={planItem}
                planDescription={planItem.descricao}
                onClick={onCardPress}
              />
            );
          })}
      </div>
    </Container>
  );
}

ContratarAssinatura.propTypes = {
  planoId: PropTypes.number.isRequired,
};
